/* unplugin-vue-components disabled */import { render } from "./ai-assistant.vue?vue&type=template&id=424fdf08"
import script from "./ai-assistant.vue?vue&type=script&lang=js"
export * from "./ai-assistant.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-chat-v2/ai-assistant/ai-assistant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "424fdf08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('424fdf08', __exports__)) {
    api.reload('424fdf08', __exports__)
  }
  
  module.hot.accept("./ai-assistant.vue?vue&type=template&id=424fdf08", () => {
    api.rerender('424fdf08', render)
  })

}


export default __exports__